import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const QueryOptimization = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Query: Query Optimization"
    videos={[
      "https://www.youtube.com/embed/TyHUU05XKMY",
      "https://www.youtube.com/embed/VI11J7vArSw",
      "https://www.youtube.com/embed/DL288YE9v0w"
    ]}
    takeaways={[]}
    questions={[
      "Draw the initial query tree for the following query and show the steps to optimize the query: SELECT P.PNO, P.DUM, E.LNAME, E.ADDRESS, E.DOB FROM PROJECT P, DEPARTMENT D, EMPLOYEE E WHERE P.DUM=D.DNO AND D.MGRSSN=E.SSN AND P.LOCATION='CHENNAI'.",
      "Find the optimal query tree for the SQL query and explain the steps in detail. Select P.Pnumber, P.Dnum, D.Address From Project as P, Department as D Where P.Dnum=D.Dnumber And D.location='SJT' And D.name=CSE",
      "Consider the following Schema Student(StudId, Fname, Lname, Major) Grades(StudId, CrsId, Grade) Course(CrsId, Cname, Credit_Points, Dept) Construct an Initial Query Tree and Optimized Query Tree using Heuristic Query Optimization Techniques for the SQL query given below: SELECT StudId, Fname FROM Student s, Grades g, Course c WHERE s.StudId=g.StudId AND g.CrsId= c.CrsId AND Grade = 'S' AND Dept= 'DataScience' AND Major = 'Al'"
    ]}
    exampleVideos={[]}
  />
);
}

export default QueryOptimization;
